/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      filterCaseStudies();

      $( '.case-study__filter-list input' ).on( 'change', function() {
        filterCaseStudies();
      } );

      $( document ).on( 'click', '.grid__pagination button', function() {
        filterCaseStudies( $( this ).attr( 'data-value' ) );
      } );

      $( document ).on( 'click', '.case-study__current-filters .remove', function() {
        const termId = $( this ).attr( 'data-term-id' );
        $( this ).closest( 'li' ).remove();
        $( '.case-study__filter-list input[value="' + termId + '"]' ).prop( 'checked', false );
        checkCurrentFilters();
        filterCaseStudies();
      } );

      $( document ).on( 'click', '.case-study__current-filters .remove-all', function() {
        $( '.case-study__filter-list input' ).prop( 'checked', false );
        checkCurrentFilters();
        filterCaseStudies();
      } );

      function checkCurrentFilters() {
        if ( $( '.case-study__current-filters ul li' ).length > 0 ) {
          $( '.case-study__current-filters' ).addClass( 'is-visible' );
        } else {
          $( '.case-study__current-filters' ).removeClass( 'is-visible' );
        }
      }

      function filterCaseStudies( page = 1 ) {
        $( '.case-study__case-studies-grid' ).addClass( 'is-loading' );

        // Get selected service information
        const serviceIds = [];
        const services = [];
        $( '#case-study-service-filters input:checked' ).each( function() {
          serviceIds.push( this.value );
          services.push( {
            'id': this.value,
            'name': $( this ).next( 'label' ).text(),
          } );
        } );

        // Get selected location information
        const locationIds = [];
        const locations = [];
        $( '#case-study-location-filters input:checked' ).each( function() {
          locationIds.push( this.value );
          locations.push( {
            'id': this.value,
            'name': $( this ).next( 'label' ).text(),
          } );
        } );

        // Create filter pills for services
        let currentFilters = '';
        if ( services.length > 0 ) {
          services.forEach( function( service ) {
            currentFilters += `
              <li class="inline-flex items-center gap-x-2 bg-brand-cream rounded-full py-1.5 px-3 text-brand-off-black"> ${service.name} <button class="remove" data-term-id="${service.id}"><svg class="icon icon-Close -mt-0.5"><use xlink:href="#icon-Close"></use></svg></button> </li>
            `;
          } );
        }

        // Create filter pills for locations
        if ( locations.length > 0 ) {
          locations.forEach( function( location ) {
            currentFilters += `
              <li class="inline-flex items-center gap-x-2 bg-brand-cream rounded-full py-1.5 px-3 text-brand-off-black"> ${location.name} <button class="remove" data-term-id="${location.id}"><svg class="icon icon-Close -mt-0.5"><use xlink:href="#icon-Close"></use></svg></button> </li>
            `;
          } );
        }

        // Update filter pills
        $( '.case-study__current-filters ul' ).html( currentFilters );
        checkCurrentFilters();

        // Set URL
        const url = new URL( window.location.href );
        url.searchParams.set( 'page', page );

        // Set URL for services
        const currentServices = [];
        if ( serviceIds.length > 0 ) {
          serviceIds.forEach( function( service ) {
            currentServices.push( service );
            url.searchParams.set( 'services', currentServices );
          } );
        } else {
          url.searchParams.delete( 'services' );
        }

        // Set URL for locations
        const currentLocations = [];
        if ( locationIds.length > 0 ) {
          locationIds.forEach( function( location ) {
            currentLocations.push( location );
            url.searchParams.set( 'locations', currentLocations );
          } );
        } else {
          url.searchParams.delete( 'locations' );
        }

        history.pushState( null, null, url.href );

        const data = {
          'll_case_study_service': serviceIds,
          'll_case_study_location': locationIds,
          'page': page,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.case-study__case-studies-grid' ).html( data.results );
            $( '.case-study__case-studies-grid' ).removeClass( 'is-loading' );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
          error: function( jqXHR, status, error ) {
            console.log( error );
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'case-study', COMPONENT );
} )( app );
